export default __webpack_public_path__ + "assets/images/59450f3ce6bdf0c358d960c313833949.svg";